export default __webpack_public_path__ + "static/media/html-svg.3f878adb.png";